import { Injectable } from '@angular/core';
import { ProductType, User } from 'src/app/interfaces/user';
import { FeatureFlagsService } from '../feature-flag/feature-flag.service';
import { UserService } from '../user/user.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class MemberShipOptionsService {

  public plan1Name: string;
  public plan2Name: string;
  public plan3Name: string;

  private plan1AnalyticsName: string;
  private plan2AnalyticsName: string;
  private plan3AnalyticsName: string;

  constructor(
    private userService: UserService,
    private configService: ConfigService,
    private featureFlagsService: FeatureFlagsService,
  ) {
    this.plan1Name = this.configService.getTextFromKey('1-plan-name');
    this.plan2Name = this.configService.getTextFromKey('2-plan-name');
    this.plan3Name = this.configService.getTextFromKey('3-plan-name');

    this.plan1AnalyticsName = this.configService.getTextFromKey('1-plan-analytics-name');
    this.plan2AnalyticsName = this.configService.getTextFromKey('2-plan-analytics-name');
    this.plan3AnalyticsName = this.configService.getTextFromKey('3-plan-analytics-name');
  }

  identiBasePlusAvailable(user: User): boolean {
    return (
      !user || (user && this.userService.isUserBasic(user.originalProductType))
    );
  }

  identiAlertAvailable(user: User): boolean {
    const smartTagEnabled = this.featureFlagsService.isEnabled('isIdentiSmartTagPlanAvailable');
    return (
      !user ||
      (user &&
        this.userService.isUserBasicOrBasicPlus(user.originalProductType) &&
        (!smartTagEnabled || !this.userService.isUserLocator(user.originalProductType)))
    );
  }

  smartTagSubAvailable(user: User): boolean {
    const smartTagEnabled = this.featureFlagsService.isEnabled('isIdentiSmartTagPlanAvailable');
    return !smartTagEnabled || !user || !this.userService.isUserLocator(user.originalProductType);
  }

  doesUserHaveMembership(user: User): boolean {
    return user.originalProductType !== ProductType.Basic;
  }

  /**
   * The product name reported to GTM. Separate from the displayed name
   * as these values are reported as conversions historically.
   */
  getUserMembershipAnalyticsName(user: User): string {
    switch (user.originalProductType) {
      case ProductType.BasicPlus:
        return this.plan1AnalyticsName;

      case ProductType.Premium:
        return this.plan2AnalyticsName;

      case ProductType.Locator:
        return this.plan3AnalyticsName;

      default:
        return this.getUserMembershipName(user);
    }
  }

  getUserMembershipName(user: User): string {
    switch (user.originalProductType) {
      case ProductType.Basic:
        return 'identibase';

      case ProductType.BasicPlus:
        return this.plan1Name;

      case ProductType.LegacyPlus:
        return 'plus';

      case ProductType.LegacyPremium:
        return 'premium';

      case ProductType.Premium:
        return this.plan2Name;

      case ProductType.Locator:
        return this.plan3Name;

      default:
        return 'identibase';
    }
  }
}
